import { createContext } from "react";
import { VersionedDataContextType } from "./type";

const defaultValue: VersionedDataContextType = {
  loading: false,
  lastSuccessfulRun: null,
  atomicPivotRuns: [],
  googleDriveSyncRuns: [],
  engineInProgress: false,
  runInProgress: null,
  mainRun: null,
  setMainRun: () => {},
  comparedRun: null,
  setComparedRun: () => {},
  runsOrdered: [],
  justTriggeredRun: null,
  setJustTriggeredRun: () => {},
  editedRun: null,
  setEditedRun: () => {},
};

export const VersionedDataContext =
  createContext<VersionedDataContextType>(defaultValue);
